import Element from 'element-ui'
// 表格
Element.Table.props.size = { type: String, default: 'small' }
// 表格列
Element.TableColumn.props.showOverflowTooltip = { type: Boolean, default: true }
Element.TableColumn.props.align = { type: String, default: 'center' }
Element.TableColumn.props.headerAlign = { type: String, default: 'center' }
Element.TableColumn.props.renderHeader = {
  type: Function, default: (h, { column, }) => {
    if (!column.label) return h('div', {}, column.label)
    column.minWidth = column.minWidth > column.label.length * 16 + 20 ? column.minWidth : column.label.length * 16 + 20
    if (column.formatter) {
      switch (column.formatter.name) {
        case 'dateFormatter':
          column.width = 120 > column.minWidth ? 120 : column.minWidth
          column.showOverflowTooltip = false
          break
        case 'dateTimeFormatter':
          column.width = 180 > column.minWidth ? 180 : column.minWidth
          column.showOverflowTooltip = false
          break
        case 'amountFormatter':
        case 'sixFormatter':
        case 'amountZeroFormatter':
        case 'noShowFormatter':
        case 'noShowsFormatter':
        case 'shiquFormatter':
        case 'areaFormatter':
          column.align = 'is-right'
          break
        default:
          break
      }
    }
    return h('span', {
    }, column.label)
  }
}
// 表单
Element.Form.props.validateOnRuleChange = { type: Boolean, default: false }
// 弹窗
Element.Dialog.props.closeOnPressEscape = { type: Boolean, default: false }
Element.Dialog.props.closeOnClickModal = { type: Boolean, default: false }
Element.Dialog.props.appendToBody = { type: Boolean, default: true }
// 输入框
Element.Input.props.clearable = { type: Boolean, default: true }
Element.Input.props.size = { type: String, default: 'medium' }
// 下拉选择
Element.Select.props.clearable = { type: Boolean, default: true }
Element.Select.props.size = { type: String, default: 'medium' }
// 按钮
Element.Button.props.size = { type: String, default: 'small' }
// 级联选择
Element.Cascader.props.clearable = { type: Boolean, default: true }
Element.Cascader.props.size = { type: String, default: 'medium' }
// 日期
Element.DatePicker.props.clearable = { type: Boolean, default: true }
Element.DatePicker.props.size = { type: String, default: 'medium' }
// 弹出框
Element.Popover.props.trigger = { type: String, default: 'hover' }
export default Element
